import {ApiRequestFailedEventArgs, QuoteData, SaleResponse} from 'protect-group-pulse-react'

export type State = {
	quoteData: QuoteData
	quoteError: ApiRequestFailedEventArgs | null
	saleError: any | null
	saleInProgress: boolean
	saleResponse: SaleResponse | null
}

export enum Action {
	quoteError,
	saleComplete,
	saleError,
	saleInProgress,
	updateQuoteData
}

export type ProtectPlusAction =
	| { type: Action.quoteError, value: ApiRequestFailedEventArgs | null }
	| { type: Action.saleComplete, value: SaleResponse | null }
	| { type: Action.saleError, value: any | null }
	| { type: Action.saleInProgress, value: boolean }
	| { type: Action.updateQuoteData, value: QuoteData }
